import { Outlet, useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Nav } from './Nav';
import { ValidarModal } from './ValidarModal';
import { ConfirmEliminarModal } from './ConfirmEliminarModal';
import { BotAdmin } from './BotAdmin';

// ── Chrome de la app autenticada: Header + Nav + modales + banners ─
export const AppLayout = ({
  currentUser, rol, setLoginUser, setLoginPass, setCurrentUser, historial,
  saved, alertas, almTab,
  modalValidar, setModalValidar, validadoPor, setValidadoPor, onConfirmValidar,
  confirmEliminar, setConfirmEliminar, onConfirmEliminarArchivado,
}) => {
  const location = useLocation();
  const currentSlug = location.pathname.split('/').pop();
  const ocultarAlertas = currentSlug === "inicio" || currentSlug === "contenedor-sdc" || (currentSlug === "almacen" && (almTab === "Reservas" || almTab === "Roturas"));
  const anchoCompleto = ["inventario-stock", "pedidos", "archivo-internacional", "internacional"].includes(currentSlug);

  return (
    <div className="min-h-screen bg-gray-50">
      {modalValidar && (
        <ValidarModal
          validadoPor={validadoPor}
          setValidadoPor={setValidadoPor}
          onCancel={() => { setModalValidar(null); setValidadoPor(""); }}
          onConfirm={onConfirmValidar}
        />
      )}
      {confirmEliminar && (
        <ConfirmEliminarModal
          onCancel={() => setConfirmEliminar(null)}
          onConfirm={() => onConfirmEliminarArchivado(confirmEliminar)}
        />
      )}

      <Header currentUser={currentUser} rol={rol} setLoginUser={setLoginUser} setLoginPass={setLoginPass} setCurrentUser={setCurrentUser} />
      <Nav rol={rol} historial={historial} modulos={currentUser?.modulos} almacen_id={currentUser?.almacen_id} />

      <div className={anchoCompleto ? "w-full px-4 md:px-6 py-4" : "max-w-2xl mx-auto px-4 py-4"}>
        {saved && <div className="mb-4 bg-green-50 border-2 border-green-400 text-green-700 rounded-xl py-6 text-center"><svg xmlns="http://www.w3.org/2000/svg" className="mx-auto mb-2" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><circle cx="12" cy="12" r="9"/><path d="M9 12l2 2l4 -4"/></svg><span className="text-xl font-semibold">Guardado correctamente</span></div>}
        {alertas.length > 0 && !ocultarAlertas && <div className="mb-3 space-y-1">{alertas.map((a, i) => <div key={i} className={`border rounded-lg px-3 py-2 text-xs font-semibold ${a.color}`}>{a.msg}</div>)}</div>}
        <Outlet />
      </div>
      {rol === "responsable" && currentUser?.modulos?.bot_admin === true && <BotAdmin />}
    </div>
  );
};
